import { render } from "./PositionShareLinksPage.vue?vue&type=template&id=455df3b2&scoped=true"
import script from "./PositionShareLinksPage.vue?vue&type=script&lang=js"
export * from "./PositionShareLinksPage.vue?vue&type=script&lang=js"

import "./PositionShareLinksPage.vue?vue&type=style&index=0&id=455df3b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455df3b2"]])

export default __exports__